import { defineCollection } from "@rebasepro/cms-types";
import gamesCollection from "./games";

// Every round of every party game: the song, and how many named it. backend/src/games.ts fills it from the event log
// (songbuzz_events: song), each round tied to its game by room and time.
const gameSongsCollection = defineCollection({
    name: "Songs played",
    singularName: "Song played",
    slug: "game_songs",
    table: "songbuzz_game_songs",
    description: "Every round of every party game: which song, and how many players named it.",
    securityRules: [{ operation: "select", roles: ["admin"] }],
    properties: {
        id: { name: "Round", type: "number", isId: "manual", columnType: "bigint", admin: { readOnly: true } },
        game: {
            name: "Game", type: "relation",
            relation: { kind: "belongsTo", target: () => gamesCollection, relationName: "game", localKey: "game_id" },
        },
        at: { name: "Played", type: "date", validation: { required: true }, admin: { readOnly: true } },
        title: { name: "Title", type: "string", admin: { readOnly: true } },
        artist: { name: "Artist", type: "string", admin: { readOnly: true } },
        year: { name: "Year", type: "number", columnType: "integer", admin: { readOnly: true } },
        deezerId: { name: "Deezer id", type: "number", columnType: "bigint", admin: { readOnly: true, hideFromCollection: true } },
        roundType: { name: "Round", type: "string", admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "round" } } },
        players: { name: "Players in the round", type: "number", columnType: "integer", admin: { readOnly: true } },
        answered: { name: "Answered", description: "Players who gave any answer", type: "number", columnType: "integer", admin: { readOnly: true } },
        named: { name: "Got it right", type: "number", columnType: "integer", admin: { readOnly: true } },
        skipped: { name: "Skipped", type: "boolean", admin: { readOnly: true } },
        source: { name: "Dealt from", description: "The music it came from", type: "string", admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "mix" } } },
    },
    admin: {
        icon: "ListMusic",
        group: "Songs",
        openEntityMode: "side_panel",
        sort: ["at", "desc"],
        display: {
            title: "title",
            subtitle: ({ entity }) => [entity.values.artist, entity.values.year].filter(Boolean).join(" · ") || undefined,
            date: "at",
        },
        listProperties: ["named", "players", "roundType", "source", "at"],
        form: {
            sections: [
                { key: "round", properties: ["title", "artist", "year", "roundType", "source", "players", "answered", "named", "skipped", "game", "at"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["id", "deezerId"] },
            ],
        },
    },
});

export default gameSongsCollection;
